export default __webpack_public_path__ + "static/media/white-woman.05191dc4.webp";